module.exports = __webpack_public_path__ + "img/3-6.043739c6.png";